module.exports = __webpack_public_path__ + "assets/img/strong-1.0dec9875.png";